export default __webpack_public_path__ + "static/media/bg-email-marketing.2c80c0ae.webp";